module.exports = __webpack_public_path__ + "media/images/openstreetmap/ScrollWheelDisabled20-4aef08ad12cab6cb1daacd177bd7d7db.png";